import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {Field} from 'redux-form';
import ValidationComponent from 'infrastructure/js/components/controls/ValidationComponent/validationComponent.js';

require('./radioButton.scss');

const PL_RadioButtonForm = (props) => {
  return <Field {...props} component={PL_RadioButton}></Field> ;
};

export const PL_RadioButton = ({name, onChange, meta, input, labelsAndValues, disabled, className }) => {

  const [value, setValue] = useState('');

  useEffect(() => {
    if (input) {
      setValue(input.value || '');
    }
  }, [input]);

  const handleInputChange = ({ target: { value } }) => {
    if (input?.onChange) {
      input.onChange(value);
    } else {
      onChange?.(value);
    }

    setValue(value);
  };

  const buttons = labelsAndValues?.map((item, index) => {return (
    <div key={typeof item.value === 'object' ? index : item.value} className={cn('radio-button-item', {selected: value === item.value})}>
      <input
        {...input} // Spread input props (value, onChange, onBlur)
        type="radio"
        id={input?.name + item.value}
        value={item.value}
        checked={value === item.value} // Check if the value is selected
        disabled={disabled}
        onChange={handleInputChange}
      />
      <label htmlFor={input?.name + item.value}>{item.label}</label>
    </div>
  )}) ?? [];

  const hasError = meta?.touched && meta?.error;

  return (
      // <div className={cn('pl-radio-button', className, { invalid: hasError })}>
      <div className={cn('pl-radio-button', className)}>
        {buttons}
        <ValidationComponent className="validation-component" {...meta} />
      </div>
  );
}

PL_RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  labelsAndValues: PropTypes.array,
  className: PropTypes.string,
};


export default PL_RadioButtonForm;

//How to use:
// <InputSection label={'Radio button test'} htmlFor="myRadioButton" className="inline left-side">
//   <RadioButton id="myRadioButton" name="myRadioButton" className="short-textfield"
//                labelsAndValues={[{value: 'value1', label: 'Label1'}, {value: 'value2', label: 'Label2'}]}
//   />
// </InputSection>
